import { render } from "./editProductType.vue?vue&type=template&id=6827ea7a&scoped=true"
import script from "./editProductType.vue?vue&type=script&lang=js"
export * from "./editProductType.vue?vue&type=script&lang=js"

import "./editProductType.vue?vue&type=style&index=0&id=6827ea7a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6827ea7a"],['__file',"src/views/brandProduct/components/editProductType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6827ea7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6827ea7a', __exports__)) {
    console.log('reload')
    api.reload('6827ea7a', __exports__)
  }
  
  module.hot.accept("./editProductType.vue?vue&type=template&id=6827ea7a&scoped=true", () => {
    console.log('re-render')
    api.rerender('6827ea7a', render)
  })

}


export default __exports__